export const latestArticlesQuery = `
  *[test == $test && _type == "article" && isPublished == true] | order(publishedAt desc) [0..2] {
    _id,
    title,
    slug,
    category,
    excerpt,
    coverImage,
    publishedAt,
    readTime
  }
`;

export const allArticlesQuery = `
  *[test == $test && _type == "article" && isPublished == true] | order(publishedAt desc) {
    _id,
    title,
    slug,
    category,
    excerpt,
    coverImage,
    publishedAt,
    readTime
  }
`;

export const articleBySlugQuery = `
  *[test == $test && _type == "article" && slug.current == $slug && isPublished == true][0] {
    _id,
    title,
    slug,
    category,
    excerpt,
    coverImage,
    body,
    publishedAt,
    readTime
  }
`;

export const paginatedJobPostsQuery = `
  *[test == $test && _type == "jobPost" && defined(publishedAt) && publishedAt <= now() && (
    !defined($lastPublishedAt) ||
    publishedAt < $lastPublishedAt ||
    (publishedAt == $lastPublishedAt && _id < $lastId)
  )] | order(publishedAt desc, _id desc) [0...$pageSize] {
    _id,
    title,
    company,
    location,
    employmentType,
    remote,
    description,
    requirements,
    applyUrl,
    publishedAt
  }
`;

export const jobPostsCountQuery = `
  count(*[test == $test && _type == "jobPost" && defined(publishedAt) && publishedAt <= now()])
`;

export const jobPostByIdQuery = `
  *[test == $test && _type == "jobPost" && _id == $jobId && defined(publishedAt) && publishedAt <= now()][0] {
    _id,
    title,
    company,
    location,
    employmentType,
    remote,
    description,
    requirements,
    applyUrl,
    publishedAt
  }
`;
